<template>
  <div class="home">
    <Menu></Menu>
    <div v-show="showList">
      <h2>ACSW Trials</h2>
      <TrialTbl @showTrial="showTrial" @reloadTrials="reloadAll" @loadXTrials="loadXTrials" @showTrialReg="displayTrialReg"  @showVolReg="displayVolReg" :trl="trials"/>
    </div>
    <div v-show="showDetail">
<!--      <h2>ACSW Trials</h2>-->
      <TrialDetail :trial="trial" @endTrialDetail="endTrialDetail" @showTrialReg="displayTrialReg" @reloadTrials="reloadAll" @refreshTrials="refreshTrial"/>
    </div>
    <div v-show="showReg">
      <h2>Register for ACSW Trial</h2>
      <TrialReg :trial="trial" @endTrialReg="endTrialReg"/>
    </div>
    <div v-show="showVol">
      <h2>Volunteer for ACSW Trial</h2>
      <VolReg :trial="trial" @endVolReg="endVolReg"/>
    </div>
  </div>
</template>

<script>
import TrialTbl from '@/components/TrialTbl.vue'
import TrialDetail from '@/components/TrialDetail.vue'
import TrialReg from '@/components/TrialReg.vue'
import VolReg from '@/components/VolReg.vue'
import Menu from '@/components/Menu.vue'


export default {
  name: "Trials",
  components: {
    TrialTbl,
    TrialDetail,
    TrialReg,
    VolReg,
    Menu,
  },
  data: () => ({
    showList: true,
    showDetail: false,
    showVol: false,
    showReg: false,
    trials: [],
    trial: {},
    judges: [],
  }),
  mounted: function () {
    console.log('Trials mounted')
    if (this.$usrStore.token == null) {
      if (localStorage.getItem('token') !== 'undefined') {
        if (localStorage.getItem('token').length > 4) {
          this.$initFromToken(localStorage.getItem('token'))
        }
      }
    }
    this.loadTrials()
    this.loadJudges()
  },
  methods: {
    loadAll: function () {
      this.loadTrials()
      this.loadJudges()
    },
    reloadAll: function() {
      this.loadAll()
    },
    refreshTrial: function (uTrial) {
      const tr_id = uTrial.id
      for (let i=0; i< this.trials.length; i++) {
        if (this.trials[i].id == tr_id) {
          this.trials[i].trialName = uTrial.trialName
          this.trials[i].id = uTrial.id
          this.trials[i].idHost = uTrial.idHost
          this.trials[i].trialName = uTrial.trialName
          this.trials[i].type = uTrial.type
          this.trials[i].city = uTrial.city
          this.trials[i].state = uTrial.state
          this.trials[i].postalCode = uTrial.postalCode
          this.trials[i].idCo = uTrial.idCo
          this.trials[i].startDate = uTrial.startDate
          this.trials[i].pubDate = uTrial.pubDate
          this.trials[i].openDate = uTrial.openDate
          this.trials[i].drawDate = uTrial.drawDate
          this.trials[i].closeDate = uTrial.closeDate
          this.trials[i].regFee = uTrial.regFee
          this.trials[i].maxRuns = uTrial.maxRuns
          break
        }
      }
    },
    hideAll: function () {
      this.showReg = false
      this.showList = false
      this.showDetail = false
      this.showVol = false;
    },
    showTrial: function (trl) {
      this.hideAll()
      this.showDetail = true
      this.trial = trl
    },
    endTrialDetail: function () {
      this.hideAll()
      this.showList = true
    },
    displayTrialReg: function (trl) {
      this.trial = trl
      this.hideAll()
      this.showReg = true
    },
    displayVolReg: function (trl) {
      this.hideAll()
      this.trial = trl
      this.showVol = true
    },
    endTrialReg: function () {
      this.hideAll()
      this.showList = true
    },
    endVolReg: function () {
      this.hideAll()
      this.showList = true
    },
    loadTrials: function () {
      console.log('loadTrials was called')
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.trial/trials', {
        token: theToken
      })
          .then(response => {
            console.log('Got response from trials')
            this.trials = response.data.trials
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadXTrials: function () {
      console.log('loadXTrials was called')
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api.trial/trialsX', {
        token: theToken
      })
          .then(response => {
            console.log('Got response from trials')
            this.trials = response.data.trials
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                } else {
                  alert(err)
                }
              }
          )
    },
    loadJudges: function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      this.error = this.jsdoc = null
      this.loading = true

      this.$http.post(this.$remote + '/api/mbrwrole', {
        token: theToken,
        role: 'Judge'
      })
          .then(response => {
            console.log('Got response from mbrwrole')
            this.judges = response.data.mbrs
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            this.loading = false
          })
          .catch(function (err) {
                if (err.response.data) {
                  alert(err.response.data.msg)
                  window.location.assign('/members')
                } else {
                  alert(err)
                }
              }
          )
    },

  }
}
</script>

<style scoped>

</style>